import { RootActionTypes } from '../../../stores/types';
import ActionTypes from '../constants/action-types';

export default function closeLabsAcceptDialog(): RootActionTypes {
  return {
    type: ActionTypes.CLOSE_ACCEPT_DIALOG,
  };
}
